import { Component, HostListener, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-internal-banner',
  templateUrl: './internal-banner.component.html',
  styleUrl: './internal-banner.component.scss',
  standalone: false,
})
export class InternalBannerComponent implements OnInit {
  @Input() message!: string;

  direction: 'vertical' | 'horizontal' = 'horizontal';

  constructor() {
    /*InternalBannerComponentConstructor*/
  }

  ngOnInit(): void {
    this.checkScreenSize();
  }

  @HostListener('window:resize', ['$event'])
  onResize(_event?: Event): void {
    this.checkScreenSize();
  }

  // xs: 0-575px
  // sm: 576-767px
  // md: 768-991px
  // lg: 992-1199px
  // xl: 1200-1399px
  // xxl: 1400px+
  private checkScreenSize(): void {
    const width = window.innerWidth;
    // xs and sm breakpoint: < 768px (Bootstrap md breakpoint)
    this.direction = width < 575 ? 'vertical' : 'horizontal';
  }
}
